import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAgentSessions } from './AgentSessionContext';

export const SessionFilters = ({ clients }) => {
    const { t } = useTranslation();
    const {
        entryPoint,
        searchQuery, setSearchQuery,
        visibilityFilter, setVisibilityFilter,
        clientFilter, setClientFilter,
    } = useAgentSessions();

    const pills = entryPoint === 'portal'
        ? [
            { key: 'my', label: t('agent_chat.filter_mine') },
            { key: 'shared', label: t('agent_chat.filter_shared') },
        ]
        : [
            { key: 'all', label: t('agent_chat.filter_all') },
            { key: 'my', label: t('agent_chat.filter_mine') },
            { key: 'shared', label: t('agent_chat.filter_shared') },
        ];

    return (
        <div className="agent-sidebar__filters">
            <div className="agent-sidebar__search">
                <i className="fas fa-search agent-sidebar__search-icon"></i>
                <input
                    type="text"
                    className="agent-sidebar__search-input"
                    placeholder={t('agent_chat.search_sessions')}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>

            {entryPoint === 'global' && clients && clients.length > 0 && (
                <div className="agent-sidebar__client-filter">
                    <select
                        value={clientFilter || ''}
                        onChange={(e) => setClientFilter(e.target.value || null)}
                        className="form-control"
                        title={t('agent_chat.filter_by_client')}
                    >
                        <option value="">{t('agent_chat.all_clients')}</option>
                        {clients.map(client => (
                            <option key={client.id} value={client.id}>{client.name}</option>
                        ))}
                    </select>
                </div>
            )}

            <div className="agent-sidebar__pills">
                {pills.map(pill => (
                    <button
                        key={pill.key}
                        className={`agent-sidebar__pill ${visibilityFilter === pill.key ? 'agent-sidebar__pill--active' : ''}`}
                        onClick={() => setVisibilityFilter(pill.key)}
                    >
                        {pill.label}
                    </button>
                ))}
            </div>
        </div>
    );
};
